import PropTypes from 'prop-types';
import React, { useContext, useState, createContext, useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';
import DetailPageModal from './detail-page-modal';

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

const noop = () => {};

const DialogContext = createContext({
    isModalOpen: false,
    openPage: noop,
});


const useDetailDialog = () => {
    const context = useContext(DialogContext);

    if (!context) {
        throw new Error('useDetailDialog must be used within a DetailDialogProvider.');
    }

    return context;
};


const DetailDialogProvider = ({ isCompanyPage, children }) => {
    const [openedPage, setOpenedPage] = useState();
    const [dialogNode, setDialogNode] = useState();
    const openPage = setOpenedPage;

    const closePage = () => {
        setOpenedPage(null);
        setDialogNode(null);
    };

    useEffect(() => {
        if (openedPage) {
            setDialogNode(ReactDOM.createPortal(
                <DetailPageModal
                    isCompanyPage={isCompanyPage}
                    url={openedPage}/>,
                document.body
            ));
        }
    }, [openedPage]);

    return (
        <DialogContext.Provider value={useMemo(() => {
            return {
                openPage,
                closePage,
            };
        }, [
            openedPage
        ])}>
            {dialogNode}
            {children}
        </DialogContext.Provider>
    );
};


const DetailDialogConsumer = DialogContext.Consumer;

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

DialogContext.displayName = 'DialogContext';

DetailDialogProvider.propTypes = {
    children: PropTypes.any,
    isCompanyPage: PropTypes.bool,
};

export {
    useDetailDialog,
    DetailDialogConsumer,
    DetailDialogProvider,
    DialogContext,
};
